/* Built In Imports */

/* External Imports */
import { Box, Image } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';

/* Services */

/**
 * Renders the Sannidhi Section Title component.
 *
 * @returns {object} titleObj component.
 * @param rest.titleObj
 * @param {object} rest - Extra styling
 * @returns {ReactElement} Sannidhi Section Title component.
 */
export default function SannidhiSectionTitle({ titleObj, ...rest }) {
  return (
    <Box
      fontFamily="FedraSerifAStdBook"
      fontSize={{
        base: titleObj?.fontSize || '24px',
        md: titleObj?.fontSize || '34px',
      }}
      fontWeight={{
        base: titleObj?.fontWeight || '600',
        md: titleObj?.fontWeight || '600',
      }}
      lineHeight={{ base: '34px', md: '39px' }}
      color={titleObj?.color || '#28231E'}
      textAlign="center"
      m={{ base: '20px auto 0 auto', md: '40px auto 0 auto' }}
      width={{ base: '80%', md: '540px', lg: '540px' }}
    >
      <Box as="h2" mb={1}>
        {titleObj?.title || titleObj?.titleText}
        <Box>{titleObj?.titleSubtext}</Box>
      </Box>
      {titleObj?.titleText != '' && (
        <Box
          textAlign="center"
          m="0 auto"
          mb="0.3rem"
          w={{ base: '80%', sm: '100%', md: '100%', lg: '100%' }}
        >
          <Image
            alt="kolam"
            title="kolam"
            src={`${config.imgPath}/d/46272/1652841553-sannidhi_kolam_darkred.png`}
          />
        </Box>
      )}
    </Box>
  );
}
